import { Button, Form, FormInstance, Input, Modal, Select } from "antd";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { VALIDATION_MESSAGE_CONFIG } from "../../../../constants/constants";
import { InviteUserModel, RoleModel } from "../../../../models/onboarding/onboarding";

interface Props {
    visible: boolean;
    data?: InviteUserModel;
    onOK: (data: any) => void;
    onCancle: () => void;
    loading?: boolean;
    useRoles?: RoleModel[];
}

export default function AddUserModal(props: Props) {
    const { t } = useTranslation();
    const formRef = useRef<FormInstance<any>>(null);

    const onOk = () => {
        formRef.current?.submit();
    };

    const submit = () => {
        const values = formRef.current?.getFieldsValue();
        props.onOK(values);
    }

    useEffect(() => {
        formRef.current?.resetFields();
        if (props.data) {
            const data = {
                email: props.data.email,
                first_name: props.data.first_name,
                last_name: props.data.last_name,
                roles: props.data.roles?.map(p => p.role),
                username: props.data.username
            };

            formRef.current?.setFieldsValue(data);
        }
    }, [props.data, formRef])

    return (
        <Modal
            className="add-user-modal-wrapper"
            title={props.data && props.data.username ? t("Onboarding.lbEditUser") : t("Onboarding.lbNewUser")}
            visible={props.visible}
            onCancel={props.onCancle}
            footer={<Button htmlType="submit" type="primary" shape="round" onClick={onOk} loading={props.loading}>
                {props.data && props.data.username ? t("Onboarding.btnSave") : t("Onboarding.btnSaveAdd")}
            </Button>}
        >
            <Form
                layout="vertical"
                className="modal-form"
                onFinish={submit}
                ref={formRef}
                validateMessages={VALIDATION_MESSAGE_CONFIG}>
                <Form.Item
                    name="username"
                    hidden>
                    <Input />
                </Form.Item>
                <Form.Item
                    name="first_name"
                    label={t("Onboarding.lbFirstName")}
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="last_name"
                    label={t("Onboarding.lbLastName")}
                    rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="roles"
                    label={t("Onboarding.lbRole")}
                >
                    <Select
                        mode="multiple"
                        allowClear>
                        {
                            props.useRoles && props.useRoles.map((item, index) =>
                                <Select.Option value={item.role} key={index}>
                                    {item.display_name}
                                </Select.Option>)
                        }
                    </Select>
                </Form.Item>

                <Form.Item
                    name="email"
                    label={t("Onboarding.lbEmail")}
                    rules={[{ type: "email" }, { required: true }]}
                >
                    <Input disabled={!!props.data?.username} type="email" />
                </Form.Item>

            </Form>
        </Modal>

    );
};
